import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';
import { MenuStyle } from 'components/organisms/projects/project-sidebar/menu.style';

const StyledMenu = styled(AntMenu)`
  ${MenuStyle};
  .ant-menu-sub.ant-menu-inline {
    background: var(--white-100);
  }
`;

export const Menu = styled(StyledMenu)`
  .ant-menu-submenu-expand-icon,
  .ant-menu-submenu-arrow {
    left: var(--spacing-01);
    right: auto;
    width: var(--spacing-05);
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    padding-left: var(--spacing-08) !important;
    padding-right: 0px;
  }

  .ant-menu-sub .ant-menu-item {
    font-weight: normal;
    padding-left: 70px !important;
    padding-right: 0;
  }
`;
